<template>
  <div>
    <div style="padding-top:10px;" v-if="!readFlag">
      <el-button size="small" icon="el-icon-back" @click="handleBack()">返回</el-button>
    </div>
    <el-card class="form-container" shadow="never" :style="{width:formWidth}">
      <el-form :model="form" :rules="rules" :label-width="formLabelWidth" ref="projectForm" :disabled="readFlag">
        <el-form-item label="项目编号" prop="pno">
          <el-input v-model="form.pno" placeholder="请输入项目编号" clearable :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item label="实验项目名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入实验项目名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="项目负责人">
          <el-select v-model="form.tnoArr" placeholder="请选择教师" multiple clearable style="width: 100%;">
            <el-option :label="item.name" v-for="item in teacherItems" :value="item.tno" :key="item.tno">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目可容纳人数">
          <el-input-number v-model="form.peopleCapacity" :min="1" :max="100" placeholder="请输入项目可容纳人数"></el-input-number>
        </el-form-item>
        <!-- <el-form-item label="项目图片">
          <multi-upload v-model="form.pictureArr"></multi-upload>
        </el-form-item> -->
        <el-form-item label="项目简介">
          <el-input :autoSize="true" v-model="form.introduction" rows=3 type="textarea" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="图文介绍">          
          <tinymce v-model="form.imageText"></tinymce>
        </el-form-item>         
        <el-form-item v-if="!readFlag">
          <el-button size="small" type="primary" @click="submitForm('projectForm')">提交</el-button>
          <el-button size="small" v-if="!isEdit" @click="resetForm('projectForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { selectProjectByNo, addProject, updateProject } from '@/api/project'
import { selectAllTeacher } from '@/api/teacher'
import CommonUtil from "@utils/common-util"
import MultiUpload from '@/components/Upload/multiUpload'
import Tinymce from '@/components/Tinymce'
const defaultForm = {
  pno: '',
  name: '',
  tnoArr: [],
  peopleCapacity: 1,
  pictureArr: [],
  introduction: '',
  imageText:''
};
export default {
  name: "projectForm",
  components: { MultiUpload,Tinymce },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    pno: {
      type: String,
    },
    readFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: Object.assign({}, defaultForm),
      rules: {        
        name: [{ required: true, message: '请填写实验项目名称', trigger: 'blur' }],
        pno: [{ required: true, message: '请输入项目编号', trigger: 'blur' }],
      },
      formLabelWidth: '140px',
      formWidth:'1100px',
      teacherItems: [],
      account:localStorage.getItem('account'), 
    }
  },
  computed: {
     ...mapState({      
      userRoles: ({ user }) => user.roles,
    }), 
    isAdmin(){
      return _.includes(this.userRoles,'superAdmin')
    } 
  },   
  created() {
    this.initInfo()
  },
  methods: {
    async initInfo() {
      let teacherResp = await selectAllTeacher()
      let allDatas = teacherResp.data.data
      this.teacherItems = allDatas
      if (this.isEdit) {
        selectProjectByNo(this.pno).then(response => {
          let formObj = response.data.data
          let pictureArr = formObj.pictures ? _.split(formObj.pictures, ',') : []
          let tnoArr = formObj.tnos ? _.split(formObj.tnos, ',') : []
          this.form = Object.assign(formObj,
            { tnoArr: tnoArr, pictureArr: pictureArr })
        })
      } else {
        this.form = Object.assign({}, defaultForm);
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form = Object.assign({}, defaultForm);
    },
    //提交信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return
        }
        this.form['pictures'] = _.join(this.form['pictureArr'], ',')
        this.form['tnos'] = _.join(this.form['tnoArr'], ',')
        if(!this.isAdmin && !_.includes(this.form['tnos'], this.account)){
           this.$message({
            message: '项目负责人须勾选本人！',
            type: 'warning',
            duration: 2000
          });
          return
        }
        // this.form['cpno'] = null
        CommonUtil.submitForm(this.isEdit, this.form, addProject, updateProject, this.handleBack)
      })
    },
    handleBack() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>
</style>
